import axios from 'axios';
import { getTokens } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/v1/capstone`;
const opts = {
  baseURL,
  headers: {},
  withCredentials: true,
  credentials: 'same-origin',
};

const tokens = getTokens();

if (tokens) {
  opts.headers.Authorization = `Bearer ${tokens.token}`;
}

const instance = axios.create(opts);

export const fetchPsapInfo = endpoint => {
  const tokens = getTokens();

  if (tokens) {
    instance.defaults.headers.Authorization = `Bearer ${tokens.token}`;
  }

  return instance.get(endpoint);
};
